import { ClickTracker } from 'bernie-analytics';
import { Link } from 'react-router-dom';
import {
  UitkExternalButton,
  UitkOverlayButton,
  UitkPrimaryButton,
  UitkSecondaryButton,
  UitkTertiaryButton
} from 'uitk-react-button';
import { UitkCheckbox } from 'uitk-react-checkbox';
import { UitkImageLink } from 'uitk-react-images';
import { UitkFakeInput } from 'uitk-react-input';
import { UitkRadioButton } from 'uitk-react-radio-button';

const ANCHOR = 'a';
const BUTTON = 'button';

export const CheckboxTracked = ClickTracker(UitkCheckbox);
export const TertiaryButtonTracked = ClickTracker(UitkTertiaryButton);
export const RadioButtonTracked = ClickTracker(UitkRadioButton);
export const PrimaryButtonTracked = ClickTracker(UitkPrimaryButton);
export const SecondaryButtonTracked = ClickTracker(UitkSecondaryButton);
export const LinkTracked = ClickTracker(Link);
export const FakeInputTracked = ClickTracker(UitkFakeInput);
export const AnchorTracked = ClickTracker(ANCHOR);
export const ImageLinkTracked = ClickTracker(UitkImageLink);
export const ButtonTracked = ClickTracker(BUTTON);
export const OverlayButtonTracked = ClickTracker(UitkOverlayButton);
export const ExternalButtonTracked = ClickTracker(UitkExternalButton);
